import { IEnvironmentInfo, IComponentInfo, IPackageInfo, IApplicationInfo, ComponentType } from './app-context.service';
import { Carriers_ModuleContextService } from './Carriers.context.service';

import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class Carriers_home_ComponentContextService {
  private readonly moduleContext: Carriers_ModuleContextService;

  constructor(moduleContext: Carriers_ModuleContextService) {
    this.moduleContext = moduleContext;
  }

  public get app(): IApplicationInfo {
    return this.moduleContext.app;
  }

  public get env(): IEnvironmentInfo {
    return this.moduleContext.env;
  }

  public get package(): IPackageInfo {
    return this.moduleContext.package;
  }

  public get component(): IComponentInfo {
    return {
      name: 'home',
      type: ComponentType.form
    }
  }
}